export default "__VITE_ASSET__8f5b7561__"